import { render, staticRenderFns } from "./NDVPantalla.vue?vue&type=template&id=7c62596a&"
import script from "./NDVPantalla.vue?vue&type=script&lang=ts&"
export * from "./NDVPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7c62596a', component.options)
    } else {
      api.reload('7c62596a', component.options)
    }
    module.hot.accept("./NDVPantalla.vue?vue&type=template&id=7c62596a&", function () {
      api.rerender('7c62596a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/NDV/NDVPantalla.vue"
export default component.exports